import { render, staticRenderFns } from "./preparatory-stage.vue?vue&type=template&id=6a0644f8&scoped=true&"
import script from "./preparatory-stage.vue?vue&type=script&lang=js&"
export * from "./preparatory-stage.vue?vue&type=script&lang=js&"
import style0 from "./preparatory-stage.vue?vue&type=style&index=0&id=6a0644f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0644f8",
  null
  
)

export default component.exports